import Typography from '@mui/material/Typography';
import React from 'react';

interface TitleProps {
    children?: React.ReactNode;
}

const Title: React.FC<TitleProps> = (props) => {
    return (
        <Typography component="h2" variant="h5" gutterBottom
            sx={{ paddingTop: '1rem' }}>
            {props.children}
        </Typography>
    );
}

export default Title;